import { FC, Fragment } from 'react'

import { AutoResponse } from '@/api/models/requests/lib/requests.types'
import CarIcon from '@/assets/svg/CarIcon.svg'

type Props = {
  autos: AutoResponse[] | null
}

const PassAuto: FC<Props> = ({ autos }) => {
  if (autos === null) {
    return null
  }

  return (
    <div className="flex items-center gap-8">
      <div className="w-20 text-grey-40">
        <CarIcon />
      </div>
      <span className="overflow-hidden whitespace-normal break-words text-grey-80">
        {autos.map((auto, index) => (
          <Fragment key={index}>
            <span className="text-16 sm:text-14">
              {auto.number}
              {auto.model && `, ${auto.model}`}
            </span>
            {index < autos.length - 1 && <span>;&nbsp; </span>}
          </Fragment>
        ))}
      </span>
    </div>
  )
}

export { PassAuto }
